module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tab-integration-wrapper"
    }
  }, [_c('div', {
    staticClass: "main-container",
    attrs: {
      "id": "main-integrations-container"
    }
  }, [(_vm.establishtmentValue) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "detail-title"
  }, [_vm._v(_vm._s(_vm.establishtmentValue.title))]), _c('h4', {
    staticClass: "detail-value"
  }, [_vm._v(_vm._s(_vm.establishtmentValue.value))])]) : _vm._e(), _vm._l((_vm.integrationValuesList), function(mainValue) {
    return _c('div', {
      staticClass: "col-xs-4"
    }, [_c('h4', {
      staticClass: "detail-title"
    }, [_vm._v(_vm._s(mainValue.title))]), _c('h4', {
      class: mainValue.class
    }, [_vm._v(_vm._s(mainValue.value))])])
  })], 2), _c('div', {
    attrs: {
      "id": "monetary-container"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('v-client-table', {
    staticClass: "data-table custom-data-table allotment-data-table",
    attrs: {
      "data": _vm.processedFiles,
      "columns": _vm.columns,
      "options": _vm.options
    }
  })], 1)]), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer-monetary-container"
    }
  }, [_c('div', {
    staticClass: "clear"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-37139c00", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37139c00"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/gridDetailsModal/tabIntegrations/tabIntegrations.pug
// module id = 1398
// module chunks = 0